import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Row, Col, Checkbox, Button, Card, message } from "antd";
import { CustomLabel } from "../../../../Common/style";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import CenterVisitTemplate from "./CenterVisitTemplate";
import { postApi, getApi } from "../../../../Services/apiService";
import {
  GET_TPA_DETAILS,
  GET_HA_DC_LIST,
  GET_HI_DC_LIST,
  GET_VH_DC_LIST
} from "../../../../Services/endpoints";
import { isNumberKey, getVisitTypeByMedicalSet, getAdditionalSetList } from "../../../../Utils";
import HouseVisitTemplate from "./HouseVisitTemplate";
import { houseIcon, dcIcon } from "../../../../Assets/Images";
import { PolicyDetails } from "../../CommonData";
import { error_message } from "../../../../Constant";
import { AppointmentDetails, BookVisitDetails } from "../../CommonData";
import { setVisitType, resetForm, setPostalBtnEnable, setDcList, setIncludedMember, setPinCode, setShowVisitType, setTpaDetails } from "../../../../Redux/BookMedicalVisit/action";
import "./bookVisit.css";
import PAGE_CONSTANTS from "../constant";
import { encrypt } from "../../../../Services/AESEncryptionDecryption";

const BookVisit = ({ selectedMember, bookAppointment }) => {
  const dispatch = useDispatch();
  const [isUnavailable, setIsUnavailable] = useState(false);
  const { AppointmentBookings } = AppointmentDetails();
  const isMedicalSetAvailable =  selectedMember?.MedicalTestSetName && selectedMember?.MedicalTestSet;
  const { [selectedMember?.MemberId]: bookState } = BookVisitDetails();
  const {
    visitType,
    isPostalBtnEnable,
    includedMembers,
    pinCode,
    tpaDetails,
    dcList,
    showVisitType,
  } = bookState || {}
  const { policyNum, proposerPincode, appSource } = PolicyDetails();
  const {FIRST, THIRD} = PAGE_CONSTANTS?.PRIORITY_INDEX;
  
  const setMembersIdForBooking = (checked, memberId) => {
    if (checked) {
      dispatch(setIncludedMember({memberId: selectedMember?.MemberId, value: [...includedMembers, memberId]}));
    } else {
      const copyIncludedMember = [...includedMembers];
      const findIndex = copyIncludedMember?.findIndex(
        (mem) => mem === memberId
      );
      copyIncludedMember?.splice(findIndex, 1);
      dispatch(setIncludedMember({memberId: selectedMember?.MemberId, value: [...copyIncludedMember]}));
    }
  };
  const getTpaListByType = (obj, type) => {
    const tpaList = [];
    if(obj?.hasOwnProperty(`tpa1_${type}`) && (obj?.[`tpa1_${type}`] === PAGE_CONSTANTS?.TPA_HA || obj?.[`tpa1_${type}`] === PAGE_CONSTANTS?.TPA_HI || obj?.[`tpa1_${type}`] === PAGE_CONSTANTS?.TPA_VH)){
      tpaList?.push(obj?.[`tpa1_${type}`])
    }
    if(obj?.hasOwnProperty(`tpa2_${type}`) && (obj?.[`tpa2_${type}`] === PAGE_CONSTANTS?.TPA_HA || obj?.[`tpa2_${type}`] === PAGE_CONSTANTS?.TPA_HI || obj?.[`tpa2_${type}`] === PAGE_CONSTANTS?.TPA_VH)){
      tpaList?.push(obj?.[`tpa2_${type}`])
    }
    if(obj?.hasOwnProperty(`tpa3_${type}`) && (obj?.[`tpa3_${type}`] === PAGE_CONSTANTS?.TPA_HA || obj?.[`tpa3_${type}`] === PAGE_CONSTANTS?.TPA_HI || obj?.[`tpa3_${type}`] === PAGE_CONSTANTS?.TPA_VH)){
      tpaList?.push(obj?.[`tpa3_${type}`])
    }
    return tpaList;
  }

  const getTpaDetails = async (Postal) => {
    try {
      const requestBody = {
        policydolist: [
          {
            policyno: policyNum,
            insureddolist: [
              {
                insuredid: appSource !== "APPTRACKER" ? selectedMember?.MemberId : selectedMember?.CustomerId,
                pincode: Postal,
              },
            ],
          },
        ],
      };
      const encryptedBody = encrypt(JSON?.stringify(requestBody));
      const result = await postApi(GET_TPA_DETAILS, {
        encodedString: encryptedBody
      });
      if (result?.data?.response?.policydolist?.length) {

        const getTpaHomeList = getTpaListByType(result?.data?.response?.policydolist[0]?.insureddolist[0], PAGE_CONSTANTS?.HOME_VISIT_TYPE?.toLowerCase());
        const getTpaDcList = getTpaListByType(result?.data?.response?.policydolist[0]?.insureddolist[0], PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE?.toLowerCase());

        const tpaValues = {
          home: getTpaHomeList?.length ? getTpaHomeList[FIRST] : null,
          homePriorityIndex: FIRST,
          homeList: getTpaHomeList?.length ? getTpaHomeList : null,
          dc: getTpaDcList?.length ? getTpaDcList[FIRST] : null,
          dcPriorityIndex: FIRST,
          dcList: getTpaDcList?.length ? getTpaDcList : null
        }
        dispatch(setTpaDetails({memberId: selectedMember?.MemberId, value: tpaValues}));
      }
    } catch (error) {
      message.error(error_message?.common_error);
      console.error(error);
    }
  };
  const formatDCListData = (dataList, type) => {
    return dataList?.map((listItem) => {
      switch (type) {
        case PAGE_CONSTANTS?.TPA_HA:
          return {
            ...listItem,
            name: listItem?.dcName,
            address: listItem?.dcAddress,
            pinCode: listItem?.pincode,
            contactNo: listItem?.contactMobileNumber,
            dcCode: listItem?.dcCode,
          };
        case PAGE_CONSTANTS?.TPA_HI:
          return {
            ...listItem,
            name: listItem?.Name,
            address: listItem?.PrimaryAddress,
            pinCode: listItem?.PinCode,
            contactNo: null,
            dcCode: listItem?.Id,
          };
        case PAGE_CONSTANTS?.TPA_VH:
          return {
            ...listItem,
            name: listItem?.name,
            address: listItem?.centerAddress,
            pinCode: listItem?.centerPincode,
            contactNo: null,
            dcCode: listItem?.id,
          };
        default:
          return null;
      }
    });
  };
  const getSelectedTpa = (Type) => {
    switch (Type) {
      case PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE:
        return { visitType: Type, tpa: tpaDetails?.dc || null };
      case PAGE_CONSTANTS?.HOME_VISIT_TYPE:
        return { visitType: Type, tpa: tpaDetails?.home || null };
      default:
        return null;
    }
  };

  const getCenterListHA = async (Postal, type, updatedTpaDetails = tpaDetails) => {
    const testSetDescriptionForHA = !isMedicalSetAvailable ? (selectedMember?.medicalTestDescriptionForHA || getAdditionalSetList(selectedMember?.MedicalTest)) : selectedMember?.medicalTestDescriptionForHA;
    try {
      setIsUnavailable(false);
      const requestBody = {
        userName: "MCHI_Service",
        password: process.env.REACT_APP_HA_TPA_PASSWORD?.split(''),
        clientCode: "220",
        testNames: testSetDescriptionForHA,
        packageNames: "",
        area: "",
        pincode: Postal,
        rangeInKm: 50,
      };
      const encryptedBody = encrypt(JSON?.stringify(requestBody))
      const result = await postApi(GET_HA_DC_LIST, {
        encodedString: encryptedBody
      });
      if (result?.data?.response?.providerList?.length) {
        dispatch(setDcList({
            memberId: selectedMember?.MemberId,
            value: formatDCListData(result?.data?.response?.providerList,PAGE_CONSTANTS?.TPA_HA),
          }));
      }
      else if(result?.data?.responseCode === 400){
          message.error(PAGE_CONSTANTS?.SERVICE_UNAVAILABLE_TEXT);
          setIsUnavailable(true);
      }
    } catch (error) {
      message.error(error_message?.common_error);
      console.error(error);
    }
  };

  const getCenterListHI = async (Postal, type, updatedTpaDetails = tpaDetails) => {
    try {
      setIsUnavailable(false);
      const requestBody = {
        UserName: "cignaws",
        Password: process.env.REACT_APP_HI_TPA_PASSWORD?.split(''),
        PinCode: Postal,
      };
      const encryptedBody = encrypt(JSON?.stringify(requestBody))
      const result = await postApi(GET_HI_DC_LIST, {
        encodedString: encryptedBody
      });
      if (result?.data?.response?.DCDetails?.length) {
        dispatch(setDcList({
          memberId: selectedMember?.MemberId,
          value: formatDCListData(result?.data?.response?.DCDetails, PAGE_CONSTANTS?.TPA_HI),
        }));
      }
      else if(result?.data?.responseCode === 400){
          message.error(PAGE_CONSTANTS?.SERVICE_UNAVAILABLE_TEXT);
          setIsUnavailable(true);
      }
    } catch (error) {
      message.error(error_message?.common_error);
      console.error(error);
    }
  };

  const getCenterListVH = async (Postal, type) => {
    try {
      setIsUnavailable(false);
      const setIds = !isMedicalSetAvailable ? getAdditionalSetList(selectedMember?.MedicalTest) : selectedMember?.MedicalTestSet;
      const requestBody = {
       pincode: Postal,
       packageId:  setIds
      };
      const encryptedBody = encrypt(JSON?.stringify(requestBody))
      const result = await postApi(GET_VH_DC_LIST, {
        encodedString: encryptedBody
      });

      if (result?.data?.response?.dcList?.length) {
        dispatch(setDcList({
          memberId: selectedMember?.MemberId,
          value: formatDCListData(result?.data?.response?.dcList, PAGE_CONSTANTS?.TPA_VH),
        }));
      }
      else if(result?.data?.responseCode === 400){
          message.error(PAGE_CONSTANTS?.SERVICE_UNAVAILABLE_TEXT);
          setIsUnavailable(true);
      }
    } catch (error) {
      message.error(error_message?.common_error);
      console.error(error);
    }
  };

  const onClickHandler = (val) => {
    if(val === PAGE_CONSTANTS?.HOME_VISIT_TYPE && !tpaDetails?.home){
      message.error("Service is not available for House Visit at your location.");
      return;
    }
    if(val === PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE && !tpaDetails?.dc){
      message.error("Service is not available for Diagnostic Center at your location.");
      return;
    }
    dispatch(setVisitType({memberId: selectedMember?.MemberId, value: val}));
    dispatch(resetForm({memberId: selectedMember?.MemberId}));
    if (
      getSelectedTpa(val)?.tpa === PAGE_CONSTANTS?.TPA_HI
    ) {
      getCenterListHI(pinCode, val);
    } else if (
      getSelectedTpa(val)?.tpa === PAGE_CONSTANTS?.TPA_HA
    ) {
      getCenterListHA(pinCode,val);
    }
    else if (
      getSelectedTpa(val)?.tpa === PAGE_CONSTANTS?.TPA_VH
    ) {
      getCenterListVH(pinCode,val);
    }
  };
  const onPostalCodeChange = (e) => {
    dispatch(setPinCode({memberId: selectedMember?.MemberId, pinCode: e?.target?.value}));
    dispatch(setShowVisitType({memberId: selectedMember?.MemberId, value: false}));
    dispatch(setVisitType({memberId: selectedMember?.MemberId, value: null}));
    dispatch(setDcList({memberId: selectedMember?.MemberId, value: null}));
    dispatch(setPostalBtnEnable({memberId: selectedMember?.MemberId, value: e?.target?.value?.length === 6}));
  };
  const onSubmitPostal = () => {
    if (pinCode && pinCode?.length === 6) {
      dispatch(setShowVisitType({memberId: selectedMember?.MemberId, value: true}));
    }
  };
  const visitTypeByTests = getVisitTypeByMedicalSet(
    selectedMember?.MedicalTestSet
  );
  const toBeAddedMemberList = selectedMember?.toBeAdded?.filter(
    (toBeMember) =>
      !AppointmentBookings?.find(
        (appointment) => appointment?.Member_id === toBeMember?.MemberId
      )
  );
  //Filter Already booked members
  useEffect(() => {
    if(AppointmentBookings?.length && includedMembers?.length){
      const filteredIncludedMember = includedMembers?.filter(
        (Member) =>
          !AppointmentBookings?.find(
            (appointment) => appointment?.Member_id === Member
          )
      )
      dispatch(setIncludedMember({memberId: selectedMember?.MemberId, value: [...filteredIncludedMember]}));
    }
  },[AppointmentBookings])

  //proposerDetails prefilled pinCode
  useEffect(() => {
    if(proposerPincode && !pinCode){
      dispatch(setPinCode({memberId: selectedMember?.MemberId, pinCode: proposerPincode}));
      dispatch(setPostalBtnEnable({memberId: selectedMember?.MemberId, value: proposerPincode?.length === 6}));
      if(proposerPincode?.length === 6){
        getTpaDetails(proposerPincode);
      }
    }
  },[proposerPincode])

  return (
    <>
      {/* <CustomLabel font_size="18" font_weight="normal">
        {`Hey ${selectedMember?.FirstName}, based on your inputs, and studying your requirements, you will need to visit a diagnostic center to complete the tests.`}
      </CustomLabel> */}
      {/* <CustomLabel
        font_size="18"
        font_weight="normal"
        style={{ marginTop: "14px" }}
      >
        {
          "Among the other insureds, Malti also needs to undergo the same tests as you, but is eligible for a home visit, Would you like to book Malti's Appointement along with yours?"
        }
      </CustomLabel> */}
      {toBeAddedMemberList?.length ? (
        <CustomLabel
          font_size="18"
          font_weight="bold"
          style={{ marginBottom: "16px" }}
        >
          {"Select Insureds To Be Added In This Booking"}
        </CustomLabel>
      ) : null}
      {toBeAddedMemberList?.map((option, index) => (
        <div className="insured-checkbox" key={`toBeAdded-${index}`}>
          <Checkbox
            checked={includedMembers?.find((mem) => mem === option?.MemberId)}
            onChange={(e) => {
              setMembersIdForBooking(e?.target?.checked, option?.MemberId);
            }}
          >
            <CustomLabel font_size="14" font_weight="normal">
              {`${option?.FirstName}`}
            </CustomLabel>
          </Checkbox>
        </div>
      ))}
      <CustomLabel
        font_size="18"
        font_weight="bold"
        style={{ marginTop: "24px", marginBottom: "16px" }}
      >
        {"1. Select your location"}
      </CustomLabel>
      <Row gutter={[32, 24]}>
        <Col md={9}>
          <div className="input_wrap">
            <input
              type="text"
              placeholder="Enter Pincode number"
              className="input_form"
              name="nomiLastName"
              data-input="digits"
              value={pinCode || ""}
              maxLength="6"
              onChange={onPostalCodeChange}
              onKeyDown={isNumberKey}
              autoComplete="off"
            />
            <span className="info_icon">
              <i className="fa fa-map-marker" aria-hidden="true"></i>
            </span>
          </div>
        </Col>
        <Col md={6}>
          <div className="submit-pincode">
            <Button
              disabled={!isPostalBtnEnable}
              onClick={onSubmitPostal}
              type="text"
            >
              {"Submit"}
              <FontAwesomeIcon
                icon={faAngleRight}
                style={{ marginLeft: "15px" }}
              />
            </Button>
          </div>
        </Col>
      </Row>
      {showVisitType && (
        <>
          <CustomLabel
            font_size="18"
            font_weight="bold"
            style={{ marginTop: "38px", marginBottom: "16px" }}
          >
            {visitTypeByTests === PAGE_CONSTANTS?.HOME_VISIT_TYPE
              ? "2. Based on your inputs and studying your requirements, you are eligible for a home visit. How do you want to proceed?"
              : "2. Based on your inputs and studying your requirements, you are eligible for a diagnostic center visit."}
          </CustomLabel>
          <div
            style={{
              display: "flex",
              position: "relative",
            }}
          >
            {visitTypeByTests &&
            visitTypeByTests === PAGE_CONSTANTS?.HOME_VISIT_TYPE ? (
              <Card
                id="hv_card"
                className={
                  visitType === PAGE_CONSTANTS?.HOME_VISIT_TYPE
                    ? "yncard round active"
                    : "yncard round"
                }
                style={{ background: "#fff", marginRight: "10px" }}
              >
                <div className="checker">
                  <input
                    className="radioIp"
                    type="radio"
                    name="radioNo"
                    value={""}
                    checked={visitType === PAGE_CONSTANTS?.HOME_VISIT_TYPE}
                    data-validation="required"
                    onChange={() =>
                      onClickHandler(PAGE_CONSTANTS?.HOME_VISIT_TYPE)
                    }
                  />
                  <div className="checkerCardIconContainer">
                    <img src={houseIcon} alt="house" />
                  </div>
                  <div className="chekerCardTextContainer">
                    <Row gutter={[10, 0]}>
                      <Col md={5}>
                        <span></span>
                      </Col>
                      <Col md={19}>
                        <CustomLabel font_size="14" font_weight="bold">
                          {"House Visit"}
                        </CustomLabel>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Card>
            ) : null}
            {visitTypeByTests &&
            (visitTypeByTests === PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE ||
              visitTypeByTests === PAGE_CONSTANTS?.HOME_VISIT_TYPE) ? (
              <Card
                id="dc_card"
                className={
                  visitType === PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE
                    ? "yncard round active"
                    : "yncard round"
                }
                style={{ background: "#fff", marginRight: "10px" }}
              >
                <div className="checker">
                  <input
                    className="radioIp"
                    checked={
                      visitType === PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE
                    }
                    value={""}
                    type="radio"
                    name="radioYes"
                    data-validation="required"
                    onChange={() =>
                      onClickHandler(PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE)
                    }
                  />
                  <div className="checkerCardIconContainer">
                    <img src={dcIcon} alt="dc" />
                  </div>
                  <div className="chekerCardTextContainer">
                    <Row gutter={[10, 0]}>
                      <Col xs={4} md={5}>
                        <span></span>
                      </Col>
                      <Col xs={17} md={19}>
                        <CustomLabel font_size="14" font_weight="bold">
                          {"Diagnostic Center"}
                        </CustomLabel>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Card>
            ) : null}
          </div>
        </>
      )}
      {isUnavailable && (
        <CustomLabel font_size="16" font_weight="bold" style={{marginTop: "24px"}}>
          {PAGE_CONSTANTS?.SERVICE_UNAVAILABLE_TEXT}
        </CustomLabel>
      )}
      {visitType === PAGE_CONSTANTS?.HOME_VISIT_TYPE && dcList?.length ? (
        <HouseVisitTemplate
          tpaDetails={getSelectedTpa(visitType)}
          selectedMember={selectedMember}
          bookAppointment={bookAppointment}
        />
      ) : null}
      {visitType === PAGE_CONSTANTS?.DIAGNOSTIC_CENTER_TYPE &&
      dcList?.length ? (
        <CenterVisitTemplate
          tpaDetails={getSelectedTpa(visitType)}
          selectedMember={selectedMember}
          bookAppointment={bookAppointment}
        />
      ) : null}
    </>
  );
};

export default BookVisit;
